import actionTypes from './actionTypes';

export const fetch = (shipment = {}) => ({
  type: actionTypes.FETCH,
  payload: {
    shipment,
  },
});

export const fetchNext = () => ({
  type: actionTypes.FETCH_NEXT,
});

export const fetchPrev = () => ({
  type: actionTypes.FETCH_PREV,
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (data = [], meta = {}) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
  meta,
});

export const reassign = ({
  shipmentId, itineraryId, driver, vehicle,
} = {}) => ({
  type: actionTypes.REASSIGN,
  payload: {
    shipmentId,
    itineraryId,
    driver,
    vehicle,
  },
});

export const reassigned = ({
  shipmentId, itineraryId, driver, vehicle,
} = {}) => ({
  type: actionTypes.REASSIGNED,
  payload: {
    shipmentId,
    itineraryId,
    driver,
    vehicle,
  },
});

export const fetchDrivers = shipment => ({
  type: actionTypes.FETCH_DRIVERS,
  payload: {
    shipment,
  },
});
export const fetchedDrivers = data => ({
  type: actionTypes.FETCHED_DRIVERS,
  payload: {
    data,
  },
});

export const manualDriverSelect = (driver, shipmentId) => ({
  type: actionTypes.MANUAL_DRIVER_SELECT,
  payload: {
    driver,
    shipmentId,
  },
});
